import { FC, useMemo } from 'react'
import clsx from 'clsx'
import PdMedia from '@/components/pd-media/pd-media'
import { Theme } from '@/common/pd-meta-components-types'
import useScrollScale from '@/hooks/tools/use-scroll-scale'
import TitleAndDesc from '@/components/standard/title-and-desc'

type Section4Type = {
  title: string
  desc: string
  mediaUrl: string
  theme?: string
  maskColor?: string
  maskDegree?: number
}

const Section4: FC<Section4Type> = ({
  title,
  desc,
  mediaUrl = '',
  theme,
  maskColor = 'transparent',
  maskDegree = 180,
}) => {
  const containerRef = useScrollScale({
    targetSelector: '.target-section4',
  })

  const maskClassName = useMemo(() => {
    if (title || desc) {
      switch (theme) {
        case Theme.Dark:
          return 'bg-gradient-to-b from-black/50'
        case Theme.Light:
          return 'bg-gradient-to-b from-white/50'
        default:
          return 'bg-gradient-to-b from-black/50'
      }
    }
    return ''
  }, [theme, title, desc])

  return (
    <div className={clsx('w-full h-fit relative', `pd-theme-${theme} bg-anti-blk`)}>
      <div className={clsx('w-full', 'h-[177.86vw] laptop:h-[56.25vw] overflow-hidden')} ref={containerRef}>
        <PdMedia src={mediaUrl} mask={false} className="target-section4 scale-200" />
      </div>
      <div
        className={clsx('absolute top-0 left-0 w-full h-[50%] pt-15 laptop:pt-28', maskClassName)}
        style={{
          background: `linear-gradient(${maskDegree}deg, ${maskColor}, transparent)`,
        }}
      >
        <TitleAndDesc title={title} desc={desc} descClass="text-white/80" titleTag="h2" />
      </div>
    </div>
  )
}

export default Section4
